export default "__VITE_ASSET__PClYSZpC__"